export const mockData = {
  company: {
    name: "Blu Digital Technologies",
    tagline: "Transforming Government & Enterprise Digital Infrastructure",
    description: "Leading SaaS agency specializing in custom websites and applications for government, school boards, law enforcement, and non-profits.",
    logo: "https://customer-assets.emergentagent.com/job_civic-web-pros/artifacts/dvvxjb78_blu_logo2-01.png"
  },

  hero: {
    title: "Building Digital Excellence for Government & Enterprise",
    subtitle: "Custom web solutions, AI-powered tools, and accessible technology that transforms how organizations serve their communities.",
    cta: "Schedule Meeting",
    calendlyLink: "https://calendly.com/d/cmg2-shw-h76/blu-exploratory-meeting",
    stats: [
      { number: "500+", label: "Projects Delivered" },
      { number: "98%", label: "Client Satisfaction" },
      { number: "24/7", label: "Support" },
      { number: "15+", label: "Years Experience" }
    ]
  },

  services: [
    {
      title: "Custom Web Development",
      description: "Full-stack development using NodeJS, Java, React, PHP, Bootstrap HTML, and MariaDB for scalable government and enterprise solutions.",
      features: ["Responsive Design", "API Integration", "Database Management", "Security Compliance"],
      icon: "Code"
    },
    {
      title: "AI-Powered Solutions",
      description: "Cutting-edge artificial intelligence implementations that streamline processes and enhance user experiences.",
      features: ["Machine Learning", "Natural Language Processing", "Automation", "Predictive Analytics"],
      icon: "Brain"
    },
    {
      title: "Government Compliance",
      description: "Specialized solutions meeting WCAG, ADA, and government accessibility standards.",
      features: ["ADA Compliance", "Security Standards", "Data Privacy", "Audit Ready"],
      icon: "Shield"
    }
  ],

  products: [
    {
      name: "NeuroAI",
      description: "Accessibility automation tool that monitors and repairs websites to ensure ADA compliance automatically.",
      logo: "https://customer-assets.emergentagent.com/job_1f3e1d1a-4725-4064-993d-5861e4f2ccb6/artifacts/mobpv0zy_Neuro%20Logo%20png.png",
      features: ["Real-time Monitoring", "Automatic Repairs", "Compliance Reports", "24/7 Scanning"],
      category: "Accessibility"
    },
    {
      name: "DynaCore CMS",
      description: "The market's only 'Accessible First' CMS targeting government and enterprise, built on React and NodeJS in an API-forward framework.",
      logo: "https://customer-assets.emergentagent.com/job_civic-web-pros/artifacts/dvvxjb78_blu_logo2-01.png",
      features: ["React Frontend", "API-Forward", "Government Ready", "Enterprise Scale"],
      category: "Content Management"
    },
    {
      name: "OfferioRFP",
      description: "AI model that enables SMBs to enter government tender space by learning about companies and writing structured proposals to government RFPs.",
      logo: "https://customer-assets.emergentagent.com/job_1f3e1d1a-4725-4064-993d-5861e4f2ccb6/artifacts/wcr3otdj_Offerio-Logo-RFP-05.png",
      features: ["AI Proposal Writing", "RFP Analysis", "Municipal Focus", "Success Tracking"],
      category: "AI Solutions"
    },
    {
      name: "OfferioAI",
      description: "Custom LLM model built for government and business. Closed-loop system ensuring data protection, preventing hallucinations, and serving as a single source of truth.",
      logo: "https://customer-assets.emergentagent.com/job_1f3e1d1a-4725-4064-993d-5861e4f2ccb6/artifacts/pwm6nj5k_Offerio-Logo.png",
      features: ["Secure AI", "No Hallucinations", "Data Privacy", "Enterprise Ready"],
      category: "AI Solutions"
    },
    {
      name: "QuickBlu",
      description: "Custom payment system enabling electronic fund transfers, preauthorized debits, and credit card processing for SMBs to collect and issue payments.",
      logo: "https://customer-assets.emergentagent.com/job_1f3e1d1a-4725-4064-993d-5861e4f2ccb6/artifacts/nuymxvt3_QuickBlu%20Logo-01.png",
      features: ["EFT Processing", "Credit Cards", "Payroll System", "Secure Transfers"],
      category: "Payments"
    }
  ],

  process: [
    {
      step: 1,
      title: "Discovery & Planning",
      description: "Understanding your requirements, compliance needs, and technical specifications.",
      duration: "1-2 weeks"
    },
    {
      step: 2,
      title: "Design & Architecture",
      description: "Creating accessible, user-friendly designs and robust system architecture.",
      duration: "2-3 weeks"
    },
    {
      step: 3,
      title: "Development & Testing",
      description: "Building your solution with continuous testing and quality assurance.",
      duration: "4-8 weeks"
    },
    {
      step: 4,
      title: "Deployment & Support",
      description: "Launching your solution with ongoing maintenance and 24/7 support.",
      duration: "Ongoing"
    }
  ],

  testimonials: [
    {
      name: "Sarah Johnson",
      position: "IT Director",
      organization: "City of Springfield",
      content: "Blu Digital transformed our digital infrastructure. Their DynaCore CMS made content management accessible and efficient for our entire team.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Michael Chen",
      position: "Superintendent",
      organization: "Metro School Board",
      content: "NeuroAI ensured our website meets all accessibility standards automatically. It's been a game-changer for our compliance requirements.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Lisa Rodriguez",
      position: "Chief Technology Officer",
      organization: "County Sheriff's Office",
      content: "The security and compliance features in their solutions gave us confidence. Their support team is exceptional.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face"
    }
  ],

  contractAwards: [
    {
      client: "Department of Transportation",
      project: "Statewide Traffic Management System",
      value: "$2.4M",
      year: "2024",
      duration: "18 months"
    },
    {
      client: "City Council Network",
      project: "Multi-Municipal Website Platform",
      value: "$1.8M",
      year: "2023",
      duration: "12 months"
    },
    {
      client: "Regional School Board Alliance",
      project: "Accessibility Compliance Platform",
      value: "$950K",
      year: "2024",
      duration: "6 months"
    }
  ],

  portfolio: [
    {
      title: "Municipal Government Portal",
      description: "Complete digital transformation for city services",
      image: "https://images.unsplash.com/photo-1486312338219-ce68e2c6b7a3?w=600&h=400&fit=crop",
      technologies: ["React", "NodeJS", "MongoDB"],
      category: "Government"
    },
    {
      title: "School Board Management System",
      description: "Comprehensive platform for educational administration",
      image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=600&h=400&fit=crop",
      technologies: ["PHP", "MariaDB", "Bootstrap"],
      category: "Education"
    },
    {
      title: "Law Enforcement Database",
      description: "Secure data management for police departments",
      image: "https://images.unsplash.com/photo-1556075798-4825dfaaf498?w=600&h=400&fit=crop",
      technologies: ["Java", "Security Stack", "API"],
      category: "Law Enforcement"
    }
  ],

  blog: [
    {
      title: "The Future of Government Digital Services",
      excerpt: "How modern web technologies are transforming citizen engagement and public service delivery.",
      category: "Technology Trends",
      readTime: "8 min read",
      date: "2024-01-15",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop",
      type: "blog"
    },
    {
      title: "ADA Compliance in 2024: What You Need to Know",
      excerpt: "Complete guide to web accessibility standards and automated compliance solutions.",
      category: "Accessibility",
      readTime: "12 min read", 
      date: "2024-01-10",
      image: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=400&h=250&fit=crop",
      type: "blog"
    },
    {
      title: "AI in Government: Opportunities and Challenges",
      excerpt: "Exploring how artificial intelligence is revolutionizing public sector operations.",
      category: "AI & Government",
      readTime: "10 min read",
      date: "2024-01-05",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop",
      type: "blog"
    }
  ],

  media: [
    {
      title: "Blu Digital Technologies Wins Major Government Contract for Accessibility Platform",
      excerpt: "Regional School Board Alliance selects Blu Digital for comprehensive accessibility compliance solution worth $950K.",
      category: "Press Release",
      date: "2024-01-20",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=250&fit=crop",
      type: "press"
    },
    {
      title: "Featured in Government Technology Magazine: The Rise of Accessible-First CMS",
      excerpt: "DynaCore CMS highlighted as revolutionary solution for government digital transformation.",
      category: "Media Coverage",
      date: "2024-01-18",
      image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400&h=250&fit=crop",
      type: "news"
    },
    {
      title: "CEO Interview: Building the Future of Government Technology",
      excerpt: "Exclusive interview discussing AI innovations and accessibility automation in public sector.",
      category: "Interview",
      date: "2024-01-12",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=250&fit=crop",
      type: "news"
    },
    {
      title: "Partnership Announcement: Expanding AI Solutions for Municipal Governments",
      excerpt: "Strategic partnership to bring OfferioAI and NeuroAI to 50+ municipal governments across North America.",
      category: "Press Release",
      date: "2024-01-08",
      image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=250&fit=crop",
      type: "press"
    },
    {
      title: "Award Recognition: Excellence in Government Digital Services",
      excerpt: "Blu Digital Technologies recognized for outstanding contribution to digital government transformation.",
      category: "Awards",
      date: "2024-01-01",
      image: "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=400&h=250&fit=crop",
      type: "news"
    }
  ]
};